import { Coding, Resource } from '@medplum/fhirtypes';
import { ConfidentialityLevel } from './constants';

export function getConfidentialityLevel(resource: Resource): ConfidentialityLevel | undefined {
  const security = resource.meta?.security;
  if (!security) {
    return undefined;
  }

  return security.find((s): s is Coding & { code: ConfidentialityLevel } =>
    Object.values(ConfidentialityLevel).includes(s.code as ConfidentialityLevel)
  )?.code;
}

export function isResourceRestricted(resource: Resource): boolean {
  return getConfidentialityLevel(resource) === ConfidentialityLevel.RESTRICTED;
}
